
exports.StringToBooleanLineItemTransformer = () => {
  return {
    convertToVersionOne : (bool) => bool.toString(),
    convertToVersionTwo : (string) => string === 'true'
  }
}


exports.ArtworkRequiredLineItemTransformer = () => {
  return {
    convertToVersionOne : (bool) => bool ? "YES" : "NO",
    convertToVersionTwo : (string) => string.toLowerCase() === "yes"
  }
}



// WEBPACK FOOTER //
// ./node_modules/@abc/transformers/src/transformers/lineItem/boolean/index.js